import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { Box } from "@similarweb/ui-components";

export const StyledBox = styled(Box).attrs(() => ({
    width: "100%",
}))`
    height: auto;
    transition: box-shadow ease 350ms;
`;

export const StyledTitleIcon = styled(SWReactIcons)`
    margin-left: 8px;
`;
